import ParametersList from "./ParametersList";

const ParametersSetupPage = () => <ParametersList />;

export default ParametersSetupPage;
